import React, { useEffect, useState } from 'react'
import Navbar from '../components/Sidebar'
import Header from '../components/HeaderCar'
import { useParams } from 'react-router-dom'
import CalendarData from '../components/Calendar.json'
import Spinner from '../components/Spinner'
import EventDetails from '../components/EventDetails'

export default function ViewEvent() {
    const { id } = useParams();
    const [eventData, setEventData] = useState({})
    const [loading, setLoading] = useState(true)

    const initData = function () {
        for (let i = 0; i < CalendarData.length; i++) {
            if (CalendarData[i].id == id) {
                var data = CalendarData[i]
            }
        }
        setEventData(data);
        setLoading(false);
    }

    useEffect(() => {
        initData();
    }, []);

    return (
        <div>
            <main role="main" className="flex-shrink-0 min-vh-100">
                <div className='container mb-5'>
                    <div className='row'>
                        {
                            (loading) ? (<Spinner padding={5} />) : (
                                <div className='row m-2 card px-0'>
                                    <h3 className='card-header'>View Event</h3>
                                    <div className='card-body'>
                                        <EventDetails Data={eventData} />
                                    </div>

                                </div>
                            )
                        }
                        <div className='row text-center mt-4'>
                            <h5><a href="/Calendar">Return to Calendar</a></h5>
                        </div>
                    </div>
                </div>
            </main>
        </div >
    )
}
